<template>
  <ol class="breadcrumb">
    <li
      class="breadcrumb-item"
    >
      <router-link :to="{ name: 'home' }">
        Home
      </router-link>
    </li>
    <li
      v-for="(breadcrumb, idx) in $store.getters['breadcrumb/get']"
      :key="idx"
      class="breadcrumb-item"
      :class="{ 'active': !!breadcrumb.link }"
    >
      <router-link
        v-if="breadcrumb.to"
        :to="breadcrumb.to"
      >
        {{ breadcrumb.name }}
      </router-link>
      <span v-if="!breadcrumb.to">
        {{ breadcrumb.name }}
      </span>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'Breadcrumb',
};
</script>
